<template>
  <div v-if="show === true" class="review-sheet" @click.stop>

    <div class="review-handle"></div>

    <div class="review-brand">
      <img
        v-if="venueLogo"
        :src="this.venueLogo || ''"
        class="review-brand-logo"
        alt="brand"
      />
      <!-- <div v-else class="review-brand-text">
        {{ brandText }}
      </div> -->
    </div>

    <div class="review-title">
      Can you help us by<br>
      sharing your experience?
    </div>

    <div class="review-google">
      <img
        src="../assets/googlereviewslogo.png"
        class="google-reviews-img"
        alt="Google Reviews"
      />
    </div>

    <div class="review-sub">
      Your opinion helps us grow
    </div>

    <button
      class="review-button"
      type="button"
      @click="onRateClick"
    >
      Rate on Google
    </button>

  </div>
</template>

<script>
export default {
  name: "GoogleReviewPrompt",
  props: {
    show: { type: Boolean, default: false },
    googleReviewUrl: { type: String, default: "" },
    brandText: { type: String, default: "" },
    venueLogo: { type: String, default: "" },
    zIndex: { type: [String, Number], default: 995 },
    closeOnOverlayClick: { type: Boolean, default: true },
  },
  emits: ["close", "rate"],
  methods: {
    onOverlayClick() {
      if (this.closeOnOverlayClick === true) {
        this.$emit("close");
      }
    },
    onRateClick() {
      this.$emit("rate");

      if (this.googleReviewUrl && this.googleReviewUrl.length > 0) {
        window.open(this.googleReviewUrl, "_blank", "noopener,noreferrer");
      }

      this.$emit("close");
    },
  },
  watch: {
    venueLogo(newVal) {
      console.log("GoogleReviewPrompt venueLogo updated:", newVal ? newVal.slice(0, 40) + "..." : newVal);
    }
  },

  created() {
    console.log("GoogleReviewPrompt created venueLogo:", this.venueLogo);
  }
};
</script>

<style scoped>
.review-sheet {
  width: 100%;
  background: #ffffff;
  border-radius: 18px 18px 0 0;
  padding: 12px 24px 26px 24px;
  padding-bottom: calc(26px + env(safe-area-inset-bottom));
}

.review-handle {
  width: 52px;
  height: 5px;
  border-radius: 999px;
  background: #d8d8dd;
  margin: 6px auto 14px auto;
}

.review-brand {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 4px;
}
.review-brand-text {
  font-size: 18px;
  font-style: italic;
  letter-spacing: 0.3px;
  color: #111;
}
.review-brand-logo {
  height: 100px;
}



.review-title {
  text-align: center;
  font-weight: 800;
  font-size: 20px;
  line-height: 26px;
  color: #111;
  margin-top: 4px;
  margin-bottom: 16px;
}

.review-google {
  text-align: center;
  margin-bottom: 8px;
}
.google-reviews-img {
  width: 183px;
  height: auto;
}

.review-sub {
  text-align: center;
  font-size: 14px;
  color: #888;
  margin-top: 8px;
  margin-bottom: 16px;
}

.review-button {
  width: 100%;
  height: 50px;
  border-radius: 999px;
  border: none;
  background: #000066;
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
}
</style>